/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from 'react';
import { fetchCallbacks } from '../../hooks/fetch-hooks/get-all-callbacks/fetch-callbacks';
import TableLayout from './table/tableLayout';
import { Columns } from './table/constants';
import { CallBackContext } from '../../contexts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faRefresh, faXmark } from '@fortawesome/free-solid-svg-icons';
import Cookies from 'js-cookie';
import { ROLES } from '../../utils/constants';
import { fetchSalesUsers } from '../../hooks/fetch-hooks/get-all-sales-users/fetch-callbacks';
import { DownLoadTable } from '../../utils/DownloadtablesInExcel';
import moment from 'moment';
import { LEAD_CREATION_SOURCE_AI_CHATBOT, LEAD_CREATION_SOURCE_OLD_FLOW, LEAD_WITH_PRESCRIPTION, LEAD_WITHOUT_PRESCRIPTION, STATUS_COLORS } from './constants';


const sheetColumns = [
    'ID',
    'Name',
    'Gender',
    'Age',
    'DOB',
    'Phone',
    'Partner',
    'Created',
    'Source',
    'Medium',
    'Campaign',
    'City',
    'State',
    'Pincode',
    'A1',
    'A1Comment',
    'A2',
    'A2Comment',
    'A3',
    'A3Comment',
    'Type',
    'Platform',
    'Lost',
    'Lost Reason',
    'Status',
    'Order Value',
    'Coupon',
    'Comment',
]

const FiltersModal = ({ filterOpen, onOpen, filterData, setFilterData }) => {

    const [tempFilterData, setTempFilterData] = React.useState({ ...filterData });

    const handleApplyFilters = () => {
        setFilterData({ ...tempFilterData });
        onOpen(false);
    }

    const handleClearFilters = () => {
        setTempFilterData({ from: '', to: '', platform: '', status: '', type: '', pageSize: 50, withPrescription: '', leadCreationSource: '' });
        setFilterData({ from: '', to: '', platform: '', status: '', type: '', pageSize: 50, withPrescription: '', leadCreationSource: '' });
        onOpen(false);
    }

    useEffect(() => {
        if (filterOpen) {
            setTempFilterData({ ...filterData });
        }
    }, [filterOpen]);

    return (
        <div className='fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center' >
            {<div className="w-full flex flex-col justify-center">
                <div
                    style={{ backgroundColor: "white", width: "36vw", marginLeft: "32vw" }}
                    className="flex flex-col gap-4 justify-center p-4"
                >
                    <div className="flex justify-between items-center">
                        <span className='text-2xl font-bold'>Filters</span>
                        <button onClick={() => onOpen(false)}>
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                    </div>
                    <hr />
                    <div className="flex flex-col gap-2">
                        <label className="font-bold">Page Size</label>
                        <input
                            type="number"
                            className="px-6 w-full font-sans py-4 col-span-2 bg-white-50"
                            value={tempFilterData.pageSize}
                            onChange={(e) => setTempFilterData({ ...tempFilterData, pageSize: e.target.value })}
                        />
                        <label className="font-bold">Date Range</label>
                        <div className="flex gap-4 items-center">
                            <div>
                                <label className="text-sm">From</label>
                                <input
                                    type="date"
                                    className="border rounded-md p-1 ml-2"
                                    value={tempFilterData.from}
                                    onChange={(e) => setTempFilterData({ ...tempFilterData, from: e.target.value })}
                                />
                            </div>
                            <div>
                                <label className="text-sm">To</label>
                                <input
                                    type="date"
                                    className="border rounded-md p-1 ml-2"
                                    value={tempFilterData.to}
                                    onChange={(e) => setTempFilterData({ ...tempFilterData, to: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <label className="font-bold">Platform</label>
                        <select
                            className="border rounded-md p-1 px-2"
                            value={tempFilterData.platform || ''}
                            onChange={(e) => setTempFilterData({ ...tempFilterData, platform: e.target.value })}
                        >
                            <option value="">All</option>
                            <option value="WATI">WATI</option>
                            <option value="WEB">WEB</option>
                            <option value="APP">APP</option>
                        </select>
                    </div>
                    <div className="flex flex-col gap-2">
                        <label className="font-bold">Status</label>
                        <select
                            className="border rounded-md p-1 px-2"
                            value={tempFilterData.status || ''}
                            onChange={(e) => setTempFilterData({ ...tempFilterData, status: e.target.value })}
                        >
                            <option value="">All</option>
                            <option value="NEW">NEW</option>
                            <option value="CALLBACK">CALLBACK</option>
                            <option value="NO_ANSWER">NO_ANSWER</option>
                            <option value="BYPASSED">BYPASSED</option>
                            <option value="LOST">LOST</option>
                            <option value="WARM">WARM</option>
                            <option value="CONVERTED">CONVERTED</option>
                        </select>
                    </div>
                    <div className="flex flex-col gap-2">
                        <label className="font-bold">Type</label>
                        <select
                            className="border rounded-md p-1 px-2"
                            value={tempFilterData.type || ''}
                            onChange={(e) => setTempFilterData({ ...tempFilterData, type: e.target.value })}
                        >
                            <option value="">All</option>
                            <option value="CALLBACK">CALLBACK</option>
                            <option value="LEAD">LEAD</option>
                            <option value="REORDER">REORDER</option>
                            <option value="LEAD_UNKNOWN_USER">LEAD_UNKNOWN_USER</option>
                        </select>
                    </div>
                    <div className="flex flex-col gap-2">
                        <label className="font-bold">Creation Source</label>
                        <select
                            className="border rounded-md p-1 px-2"
                            value={tempFilterData.leadCreationSource || ''}
                            onChange={(e) => setTempFilterData({ ...tempFilterData, leadCreationSource: e.target.value })}
                        >
                            <option value="">All</option>
                            <option value={LEAD_CREATION_SOURCE_AI_CHATBOT}>AI Chatbot</option>
                            <option value={LEAD_CREATION_SOURCE_OLD_FLOW}>Old Flow</option>
                        </select>
                    </div>
                    <div className="flex flex-col gap-2">
                        <label className="font-bold">Prescription Status</label>
                        <select
                            className="border rounded-md p-1 px-2"
                            value={tempFilterData.withPrescription || ''}
                            onChange={(e) => setTempFilterData({ ...tempFilterData, withPrescription: e.target.value })}
                        >
                            <option value="">All</option>
                            <option value={LEAD_WITH_PRESCRIPTION}>With Prescription</option>
                            <option value={LEAD_WITHOUT_PRESCRIPTION}>Without Prescription</option>
                        </select>
                    </div>
                    <div className="flex justify-end gap-2 mt-4">
                        <button
                            className="bg-gray-200 px-4 py-1 rounded-md"
                            onClick={handleClearFilters}
                        >
                            Clear
                        </button>
                        <button
                            className="bg-[#00A48B] text-white-50 px-4 py-1 rounded-md"
                            onClick={handleApplyFilters}
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>}
        </div>
    )
}


function RequestCallbacks() {

    const user = Cookies.get('user') && JSON.parse(Cookies.get('user'));
    const userRoles = Cookies.get('roles') && JSON.parse(Cookies.get('roles'));

    const urlParams = new URLSearchParams(location.search);
    const page = parseInt(urlParams.get('page')) >= 1 ? parseInt(urlParams.get('page')) : 1;
    const searchStr = urlParams.get('search') || '';
    const pageSizeStr = parseInt(urlParams.get('size')) || 50;
    const fromStr = urlParams.get('from') || '';
    const toStr = urlParams.get('to') || '';
    const platformStr = urlParams.get('platform') || '';
    const statusStr = urlParams.get('status') || '';
    const typeStr = urlParams.get('type') || '';
    const leadCreationSourceStr = urlParams.get('leadCreationSource') || '';
    const withPrescriptionStr = urlParams.get('withPrescription') || '';

    const [currentPage, setCurrentPage] = useState(page);
    const [search, setSearch] = useState(searchStr);
    const [tableData, setTableData] = useState([]);
    const [total, setTotal] = useState(0);
    // eslint-disable-next-line no-unused-vars

    const [filterOpen, setFilterOpen] = useState(false);
    const [filterData, setFilterData] = useState({
        from: fromStr,
        to: toStr,
        platform: platformStr,
        status: statusStr,
        type: typeStr,
        pageSize: pageSizeStr,
        leadCreationSource: leadCreationSourceStr,
        withPrescription: withPrescriptionStr
    });

    const [selectedSupportId, setSelectedSupportId] = useState('');

    const { data: callbacksData, refetch } = fetchCallbacks(currentPage, search, filterData, (userRoles.includes(ROLES.ADMIN) || userRoles.includes(ROLES.SUPER_ADMIN) || userRoles.includes(ROLES.SUPER_SUPPORT) || userRoles.includes(ROLES.MARKETING)) ? selectedSupportId ? selectedSupportId : null : user?.id);
    const { data: salesUsersData } = (userRoles.includes(ROLES.ADMIN) || userRoles.includes(ROLES.SUPER_ADMIN) || userRoles.includes(ROLES.SUPER_SUPPORT)) ? fetchSalesUsers() : { data: null };

    useEffect(() => {
        const updateUrl = () => {
            const url = new URL(location);
            url.searchParams.set('page', currentPage);
            url.searchParams.set('size', filterData.pageSize);
            url.searchParams.set('search', search);
            url.searchParams.set('from', filterData.from);
            url.searchParams.set('to', filterData.to);
            url.searchParams.set('platform', filterData.platform);
            url.searchParams.set('status', filterData.status);
            url.searchParams.set('type', filterData.type);
            url.searchParams.set('leadCreationSource', filterData.leadCreationSource);
            url.searchParams.set('withPrescription', filterData.withPrescription);
            history.pushState({}, '', url);
        };
        updateUrl();
        refetch();
    }, [currentPage, history, location, selectedSupportId, filterData]);

    useEffect(() => {
        if (currentPage === 1) {
            const updateUrl = () => {
                const url = new URL(location);
                url.searchParams.set('search', search);
                history.pushState({}, '', url);
            };
            updateUrl();
            refetch();
        } else {
            setCurrentPage(1)
        }
    }, [search])

    useEffect(() => {
        if (callbacksData?.data?.data) {
            setTableData(callbacksData?.data?.data?.rows);
            setTotal(callbacksData?.data?.data?.count);
        }
    }, [callbacksData]);

    const columns = useMemo(() => {
        return [
            ...Columns.filter(column => userRoles.includes(ROLES.MARKETING) ? (column.Header !== 'Lost' && column.Header !== 'Lost Reason' && column.Header !== 'A1' && column.Header !== 'A2' && column.Header !== 'A3' && column.Header !== 'Comment') : (column.Header !== 'Medium' && column.Header !== 'Campaign' && column.Header !== 'City' && column.Header !== 'State' && column.Header !== 'Pincode')),
        ]
    }, [userRoles]);


    return (
        <div className="p-7 h-full overflow-y-scroll bg-gray-50">
            <div className='flex gap-4 items-center w-full'>
                <button
                    onClick={() => {
                        if (currentPage !== 1) {
                            setCurrentPage(1)
                        } else {
                            refetch();
                        }
                    }}
                    className=' flex gap-2 items-center justify-center bg-[#00A48B] py-[1rem] px-[1.5rem] rounded-lg my-[0.5rem]'
                >
                    <FontAwesomeIcon icon={faRefresh} color='#fff' />
                    <span className='text-[1.2rem] font-medium text-[#fff]' >Refresh</span>
                </button>
                <button className="flex gap-2 items-center justify-center bg-[#00A48B] py-[1rem] px-[1.5rem] rounded-lg my-[0.5rem] text-white-50" onClick={() => DownLoadTable('Leads', 'Leads', sheetColumns, tableData.map(row => [row?.id, row?.mapUserPatient?.Patient?.name || row?.name, row?.mapUserPatient?.Patient?.gender, moment().diff(moment(row?.mapUserPatient?.Patient?.dob), 'years'), moment(row?.mapUserPatient?.Patient?.dob).format("DD-MM-YYYY"), row?.phoneNumber || row?.mapUserPatient?.Patient?.contact_no, row?.partner?.name, moment(row?.createdAt).format('DD-MM-YYYY'), row?.source, row?.medium, row?.campaign, row?.additionalDetails?.location?.district, row?.additionalDetails?.location?.state, row?.additionalDetails?.location?.pincode, row?.additionalDetails?.a1?.date ? moment(row?.additionalDetails?.a1?.date).format('DD-MM-YYYY') : '', row?.additionalDetails?.a1?.comment, row?.additionalDetails?.a2?.date ? moment(row?.additionalDetails?.a2?.date).format('DD-MM-YYYY') : '', row?.additionalDetails?.a2?.comment, row?.additionalDetails?.a3?.date ? moment(row?.additionalDetails?.a3?.date).format('DD-MM-YYYY') : '', row?.additionalDetails?.a3?.comment, row?.type, row?.additionalDetails?.platform, row?.additionalDetails?.lost, row?.additionalDetails?.lostReason, row?.status, row?.additionalDetails?.orderValue, row?.additionalDetails?.couponCode || "", row?.comment]))}>
                    <span className='text-[1.2rem] font-medium text-[#fff]' >Download Excel</span>
                </button>
                {
                    (userRoles.includes(ROLES.ADMIN) || userRoles.includes(ROLES.SUPER_ADMIN) || userRoles.includes(ROLES.SUPER_SUPPORT)) && <select value={selectedSupportId} onChange={(e) => setSelectedSupportId(e.target.value)} className='bg-gray-100 rounded-md px-4 py-2'>
                        <option value=''>All</option>
                        <option value={user?.id}>Self</option>
                        {salesUsersData?.data?.data?.rows?.map((user) => (
                            <option key={user?.id} value={user?.id}>{user.name}</option>
                        ))}
                    </select>
                }
                <button
                    className="bg-gray-200 px-4 py-1 rounded-md"
                    onClick={() => setFilterOpen(true)}
                >
                    Filters
                </button>

                {
                    (filterData.from || filterData.to || filterData.platform || filterData.status || filterData.type || filterData.leadCreationSource || filterData.withPrescription) && <button
                        className="bg-red-600 px-4 py-1 rounded-md text-white-50"
                        onClick={
                            () => {
                                setFilterData({ from: '', to: '', platform: '', status: '', type: '', pageSize: 50, withPrescription: '', leadCreationSource: '' });
                                setFilterOpen(false);
                            }
                        }
                    >
                        Clear Filter
                    </button>
                }
            </div>

            <div className="flex gap-4 items-center">
                <input
                    className="px-6 w-full font-sans bg-slate-100 py-4"
                    placeholder={`${total} records...`}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>
            <div className="legend-keys flex justify-end gap-4 items-center">
                <div className={`legend-key flex items-center gap-2 text-[${STATUS_COLORS.CALLBACK}]`}>
                    <FontAwesomeIcon icon={faCircle} style={{ color: STATUS_COLORS.CALLBACK, fontSize: "12px", marginRight: "5px" }} />
                    Callback
                </div>
                <div className={`legend-key flex items-center gap-2 text-[${STATUS_COLORS.NO_ANSWER}]`}>
                    <FontAwesomeIcon icon={faCircle} style={{ color: STATUS_COLORS.NO_ANSWER, fontSize: "12px", marginRight: "5px" }} />
                    No Answer
                </div>
                <div className={`legend-key flex items-center gap-2 text-[${STATUS_COLORS.BYPASSED}]`}>
                    <FontAwesomeIcon icon={faCircle} style={{ color: STATUS_COLORS.BYPASSED, fontSize: "12px", marginRight: "5px" }} />
                    Bypassed
                </div>
                <div className={`legend-key flex items-center gap-2 text-[${STATUS_COLORS.LOST}]`}>
                    <FontAwesomeIcon icon={faCircle} style={{ color: STATUS_COLORS.LOST, fontSize: "12px", marginRight: "5px" }} />
                    Lost
                </div>
                <div className={`legend-key flex items-center gap-2 text-[${STATUS_COLORS.WARM}]`}>
                    <FontAwesomeIcon icon={faCircle} style={{ color: STATUS_COLORS.WARM, fontSize: "12px", marginRight: "5px" }} />
                    Warm
                </div>
                <div className={`legend-key flex items-center gap-2 text-[${STATUS_COLORS.CONVERTED}]`}>
                    <FontAwesomeIcon icon={faCircle} style={{ color: STATUS_COLORS.CONVERTED, fontSize: "12px", marginRight: "5px" }} />
                    Converted
                </div>
            </div>
            <CallBackContext.Provider value={{ data: tableData, columns, refetch }}>
                {tableData.length > 0 && <TableLayout />}
            </CallBackContext.Provider>
            <div className="btn_div">
                <button disabled={currentPage <= 1} onClick={() => setCurrentPage(currentPage - 1)} className="previous">Previous</button>
                <span className="pageindex">Page {currentPage} of {Math.ceil(total / filterData.pageSize)}</span>
                <button disabled={currentPage >= Math.ceil(total / filterData.pageSize)} onClick={() => setCurrentPage(currentPage + 1)} className="next">Next</button>
            </div>
            {filterOpen && <FiltersModal filterOpen={filterOpen} onOpen={setFilterOpen} filterData={filterData} setFilterData={setFilterData} />}
        </div>
    );
}

export default RequestCallbacks;
